<template>
    <client-only>
        <el-dialog 
            :align-center="alignCenter" 
            :show-close="showClose"
            @update:model-value="$emit('update:visible', $event)" 
            :model-value="visible"
            @close="close"
            v-bind="attrs"
        >
            <slot></slot>
        </el-dialog>
    </client-only>
</template>
<script setup lang="ts">
interface Props {
    alignCenter?: boolean,
    showClose?: boolean,
    visible: boolean,
}
const props = withDefaults(defineProps<Props>(), {
    alignCenter: true,
    showClose: false,
    visible: false,
})
const emit = defineEmits(['update:visible'])
const close = ()=>{
    emit('update:visible', false)
}

const attrs = useAttrs()

</script>
